// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2103":"css/app.6997","9208":"css/admin-app.6997"}[chunkId] + ".css";
};